/*
 * ゲーム（ポケカ / デュエマ / …）の表示切替。
 * html[data-game] と window.FUMOTCG_GAMES は sections/header.liquid 冒頭のインラインスクリプトが決める
 * （sessionStorage 'fumotcg:game' と、サーバーがパスから判定した data-game-server から）。
 * ここでは、その値に合わせてロゴのリンク先・買取サイトへのリンク先・検索フォームの隠しフィールド・ヘッダーの属性・メニューで開くタイトルを揃える。
 * ロゴ横パーツなどの表示切替自体は CSS（.game-only-<key>）が行い、メニューはタイトルごとのアコーディオンをここで開く。
 */
(function () {
  var games = window.FUMOTCG_GAMES || {};
  var game = document.documentElement.getAttribute('data-game') || 'pokemon';
  var info = games[game] || games.pokemon || { title: 'ポケモンカード', home: '/' };

  document.querySelectorAll('[data-game-home]').forEach(function (el) {
    el.setAttribute('href', info.home + (info.home.indexOf('?') >= 0 ? '&' : '?') + 'ref=logo&pos=' + game);
  });
  document.querySelectorAll('[data-game-buy]').forEach(function (el) {
    if (info.buy) el.setAttribute('href', info.buy);
  });
  document.querySelectorAll('[data-game-card-title]').forEach(function (el) {
    el.setAttribute('data-card-title', info.title);
    el.setAttribute('data-game-key', game);
  });
  document.querySelectorAll('input[data-game-filter]').forEach(function (el) {
    el.value = info.title + ',common';
  });
  document.querySelectorAll('input[data-game-param]').forEach(function (el) {
    el.value = game;
  });
  document.querySelectorAll('[data-current-game]').forEach(function (el) {
    el.setAttribute('data-current-game', game);
  });

  var drawer = document.getElementById('Details-menu-drawer-container');
  var sections = document.querySelectorAll('[data-game-section]');
  function openCurrentSection() {
    sections.forEach(function (el) {
      el.open = el.getAttribute('data-game-section') === game;
    });
  }
  openCurrentSection();
  sections.forEach(function (el) {
    var summary = el.querySelector(':scope > summary');
    // テーマ標準の MenuDrawer は drawer 内の全 summary を横から出るサブメニューとして扱うため、見出しのクリックはそこへ届けない。
    el.addEventListener('click', function (event) {
      if (event.target.closest('summary') === summary) event.stopPropagation();
    }, true);
  });
  var desktop = window.matchMedia('(min-width: 990px)');
  // PC では 2 階層目（シングルカードなど）を開いたまま並べる。見出しのクリックはテーマ標準のサブメニュー処理にも details の開閉にも渡さない。
  function openSubmenus() {
    if (!desktop.matches) return;
    document.querySelectorAll('[data-game-section] .menu-drawer__menu details').forEach(function (el) {
      el.open = true;
    });
  }

  // メニューを閉じるとテーマ標準の処理が中の details を全部閉じるので、開くたびに今のタイトルを開き直す。
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      if (!drawer.open) return;
      openCurrentSection();
      openSubmenus();
    });
    drawer.addEventListener('click', function (event) {
      if (!desktop.matches) return;
      var summary = event.target.closest('summary');
      if (!summary || !summary.closest('[data-game-section] .menu-drawer__menu')) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }
})();
